import React from 'react';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';
import { BRAND_COLORS } from '../../../styles/theme';
import { useTranslation } from '../../../i18n';

interface LoadingStateProps {
  error?: string | null;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ error }) => {
  const { t } = useTranslation();

  if (error) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 3,
        }}
      >
        <Alert severity="error" sx={{ maxWidth: 600 }}>
          {error}
        </Alert>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <CircularProgress size={60} sx={{ color: BRAND_COLORS.forestGreen.main }} />
      <Typography variant="h6" sx={{ color: BRAND_COLORS.forestGreen.main }}>
        {t('common.loadingDashboard')}
      </Typography>
    </Box>
  );
};
